function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { GET_AUTOCOMPLETE_LIST_SUCCESS, SET_AUTOCOMPLETE_LIST, SET_AUTOCOMPLETE_LOADING, SET_MANUAL_ADDRESS_ENTER, SET_SELECTED_PLACE_BY_ID } from 'swag-client-common/redux/partials/autocomplete/autocomplete.action';
const initialState = {
  isAddressEnteredManually: false,
  isLoading: false,
  autocompleteList: [],
  // @todo. auto generated. fix this error
  // @ts-ignore
  selectedOption: null
};
export const autocompleteReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AUTOCOMPLETE_LIST_SUCCESS:
    case SET_AUTOCOMPLETE_LIST:
      {
        return _objectSpread({}, state, {
          autocompleteList: action.payload.autocompleteList
        });
      }
    case SET_MANUAL_ADDRESS_ENTER:
      {
        const isAddressEnteredManually = action.payload ? action.payload.isAddressEnteredManually : !state.isAddressEnteredManually;
        return _objectSpread({}, state, {
          isAddressEnteredManually,
          autocompleteList: [],
          // @todo. auto generated. fix this error
          // @ts-ignore
          selectedOption: null
        });
      }
    case SET_SELECTED_PLACE_BY_ID:
      {
        const {
          address
        } = action.payload;
        return _objectSpread({}, state, {
          selectedOption: address
        });
      }
    case SET_AUTOCOMPLETE_LOADING:
      {
        const {
          payload: {
            isLoading
          }
        } = action;
        return _objectSpread({}, state, {
          isLoading
        });
      }
    default:
      {
        return state;
      }
  }
};